<template>
  <MessageLayout
    image="./email-sent.svg"
    altText="email sent"
    title="Check your email"
  >
    An email has been sent to
    <strong class="email-indicator">{{ email }}</strong>
    <p>
      Please follow the instructions in the verification email to finish
      creating your Nobl9 account.
    </p>
    <template v-slot:action>
      <ResendEmail />
    </template>
  </MessageLayout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import MessageLayout from "@/modules/messages/MessageLayout.vue";
import ResendEmail from "@/modules/ResendEmail.vue";
import store from "@/store";

@Options({
  components: { ResendEmail, MessageLayout },
})
export default class EmailSent extends Vue {
  $store = store;

  get email(): string {
    return this.$store.state.prospect.email;
  }
}
</script>

<style lang="scss" scoped>
.message {
  :deep(.message__image) {
    padding-right: 60px;
  }
}

.email-indicator {
  display: block;
}
</style>
